const makeRequest = <T>(method: "GET" | "POST", url: string, {headers, params = ""}: {headers?: Record<string, string>, params?: Record<string, string> | string} = {}): Promise<T> => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open(method, url);

        xhr.addEventListener("load", () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(xhr.response);
            } else {
                reject({
                    status: xhr.status,
                    statusText: xhr.statusText
                });
            }
        });

        xhr.addEventListener("error", () =>
            reject({
                status: xhr.status,
                statusText: xhr.statusText
            })
        );

        if (headers) {
            Object.keys(headers).forEach( (key) => {
                xhr.setRequestHeader(key, headers[key]);
            });
        }

        if (params && typeof params === 'object') {
            params = Object.keys(params).map(key => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
            }).join('&');
        }

        xhr.send(params as string);
    });
}
export class Http {
    public static get<T>(url: string): Promise<T> {
        return makeRequest("GET", url);
    }

    public static post<T>(url: string, params: string): Promise<T> {
        return makeRequest("POST", url, {params});
    }
}
